(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelEngineFilter',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	// form.load = function load($form)
	// {
	// };
}(jQuery, window.Adzuki || {}));


